<template>
    <div id="app">
        <vue-snotify></vue-snotify>
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'App',
};
</script>
